<script lang="ts">
    export let message;
</script>

<div class="w3-panel w3-pale-red w3-text-red w3-leftbar w3-border-red text-red-500">
    {message}
</div>